define('extensions/knockoutExtenders/deepComparer',[
    'lib/knockout',
    'lib/lodash4'
],function (ko, _) {
    "use strict";

    // Extends an observable so that it uses deep comparison as its knockout equality comparer.
    //
    // One way in which this is useful is for checking whether the value of an observableArray has changed
    // for the purposes of notifying validation subscribers.
    //
    // NOTE: This extension is not likely to play nicely on the same observable as the notify extension,
    // because they both modify the observable's equalityComparer.
    ko.extenders.deepComparer = function(target) {
        target.equalityComparer = _.isEqual;
        return target;
    };
});
